
export default {
  props: {
    url: String,
    brand: String,
    is_hidden: Boolean
  }
};
